export const FACILITY_KEY = 'anläggning';
export const PROJNR_KEY = 'projNr';
export const LINKED_PROJECT_KEY = 'linkedProject';
export const SESSION_SHUNTS_KEY = 'SessionShunts'
export const SESSION_MODIFIED_SHUNTS_KEY = 'ModifiedShunts'
export const SESSION_ADDONS_KEY = 'ShuntAddons';
export const CURRENT_SHUNT = 'CurrentShunt';